import { render, staticRenderFns } from "./reset_pwd_dialog.vue?vue&type=template&id=651dd4cc"
import script from "./reset_pwd_dialog.vue?vue&type=script&lang=js"
export * from "./reset_pwd_dialog.vue?vue&type=script&lang=js"
import style0 from "./reset_pwd_dialog.vue?vue&type=style&index=0&id=651dd4cc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports